// Class: starling.filters.CompositeLayer

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var CompositeLayer = function() {
	this.x = this.y = 0;
	this.alpha = 1.0;
	this.color = 16777215;
	this.mode = "normal";
}

// Meta

CompositeLayer.__name__ = "starling.filters.CompositeLayer";
CompositeLayer.__isInterface__ = false;
CompositeLayer.prototype = {
	
};
CompositeLayer.prototype.__class__ = CompositeLayer.prototype.constructor = $hxClasses["starling.filters.CompositeLayer"] = CompositeLayer;

// Init



// Statics




// Export

exports.default = CompositeLayer;